import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import clsx from 'clsx';
import { useStyles } from 'features/command-center/components/shared';

export const ExpandableRow = ({ columns, row }) => {
  const classes = useStyles();

  return (
    <TableRow hover>
      <TableCell />

      {columns.map(col => {
        if (col.options.display !== true) return null;

        const isWeekColumn = col.name.includes('weekOfMonth');

        return (
          <TableCell key={col.name} align={isWeekColumn ? 'right' : 'left'}>
            <span className={clsx(classes.regularWeightRow, classes.paddingLeft)}>
              {col?.options?.customBodyRender
                ? col.options.customBodyRender(row[col.name])
                : row[col.name]}
            </span>
          </TableCell>
        );
      })}
    </TableRow>
  );
};
